module.exports = __webpack_public_path__ + "static/media/Vue-SDB_01-Rose-nenuphar.8f8fee08.jpg";